/**
 * 爆款情报来源平台 → 中文标签(单一源)。
 *
 * 批4(2026-07-21)走查实锤:此前 5 个组件各自维护本地 map,快手上线后 3 处漏词条
 * (数字人/视频/海报蓝图条直接渲染出「来自 kuaishou」原码),2 处漏 wechat_channels
 * (落库真值)。新增平台只改这里。
 */
export const PLATFORM_LABEL: Record<string, string> = {
  douyin: "抖音",
  kuaishou: "快手",
  xiaohongshu: "小红书",
  wechat: "视频号",
  wechat_channels: "视频号",
  // 1008 TikHub 扩展:ai 侧平台码 xigua / toutiao(头条只解析视频)
  xigua: "西瓜视频",
  toutiao: "今日头条",
};

/** 取平台中文标签;未知平台原样返回(诚实展示,不吞新值)。 */
export function platformLabel(key: string | null | undefined): string | null {
  if (!key) return null;
  return PLATFORM_LABEL[key] ?? key;
}
